export type MediaItem = {
  id: string;
  name: string;
  type: 'image' | 'video';
  url: string;
  thumbUrl?: string;
  createdAt: Date;
  messageId: string;
};

export type MediaDateGroup = {
  dateLabel: string;
  dateKey: string;
  items: MediaItem[];
};

export enum MediaType {
  Photo = 'Photo',
  Video = 'Video',
}

type HeaderRow = { kind: 'header'; dateLabel: string; dateKey: string };
type TilesRow = { kind: 'tiles'; items: MediaItem[] };
export type VirtualRow = HeaderRow | TilesRow;
